import React from "react";
import { connect } from "react-redux";
import { fetchMyCircles } from "../../store/my_circles/operations";
import { navigate } from "../../store/navigation/operations";
import LoadingIndicator from "../../components/LoadingIndicator";
import { Translate, I18n } from "react-redux-i18n";
import MyCircleCard from "../../components/MyCircleCard";
import ReduxLinkDecorator from "../../containers/ReduxLinkDecorator";

import { getCircles, loadingInitialCirclesList } from "../../store/my_circles/selectors";
import DashboardNewCircle from "../../components/DashboardNewCircle";
import { NonIdealState, Button } from "@blueprintjs/core";
import { isLoggedIn, loggedInUserGuid } from "../../store/iam/selectors";
import {isSuperUser} from  "../../store/users/selectors";

class MyCirclesSection extends React.Component {
  constructor(props) {
    super(props);
    this.circleCardClicked = this.circleCardClicked.bind(this);
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.props.isLoggedIn !== prevProps.isLoggedIn) {
      this.props.fetchMyCircles();
    }
  }

  componentDidMount() {
    if (this.props.isLoggedIn) {
      this.props.fetchMyCircles();
    }
  }
  circleCardClicked(circle) {
    if (circle.status === "pending") {
      this.props.navigate(`/circle/${circle.guid}`);
    } else {
      this.props.navigate(`/circle-toolbox/${circle.guid}`);
    }
  }
  render() {
    return (
      <div className={`content-wrapper ${this.props.circles ? "has-sidebar" : null}`}>
        <div className="wide-content">
          <h1 className="bp3-heading">
            <Translate value="my_circles.heading" />
          </h1>
          <div className="blocked-card-list my-circles">
            {this.props.loading && <LoadingIndicator />}
            {!this.props.loading && !this.props.circles && (
              <div className="custom-card">
                <NonIdealState
                  icon="new-object"
                  title={I18n.t("my_circles.you_have_no_circles")}
                  description={I18n.t("my_circles.setup_new_circle")}
                  action={
                    <ReduxLinkDecorator goTo="new-circle">
                      <Button intent="primary" fill={false}>
                        <Translate value="my_circles.create_circle" />
                      </Button>
                    </ReduxLinkDecorator>
                  }
                />
                <div className="spacer-16" />
              </div>
            )}
            {!this.props.loading &&
              this.props.circles &&
              Object.values(this.props.circles).map((circle, index) => (
                <MyCircleCard key={circle.guid} circle={circle} onClick={(_) => this.circleCardClicked(circle)} />
              ))}
          </div>
        </div>

        {this.props.circles && this.props.loggedAsSuperUser &&
          <div className="sidebar-content">
            <DashboardNewCircle />
          </div>
        }
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    isLoggedIn: isLoggedIn(state),
    loading: loadingInitialCirclesList(state),
    circles: getCircles(state),
    locale: state.i18n.locale,
    loggedAsSuperUser: isSuperUser(state, loggedInUserGuid(state))
  };
};

const mapDispatchToProps = (dispatch) => ({
  fetchMyCircles: (id) => dispatch(fetchMyCircles()),
  navigate: (to) => dispatch(navigate(to)),
});

export default connect(mapStateToProps, mapDispatchToProps)(MyCirclesSection);
